
import { defineComponent, ref, Ref, onMounted, watch, inject } from "vue";
import { fabric } from "fabric";
import { makeRulerCanvas, drawTopRuler } from "./Rulers";
import { canvas } from "@/canvas-api/Canvas";
import { zoomValue, isZooming } from "@/canvas-api/Zoom";
import { LineProperties } from "@/types";

export default defineComponent({
  name: "Rulers",
  setup() {
    const topRulerRef = ref<HTMLCanvasElement>();
    const topRulerCanvas = ref<fabric.Canvas>(new fabric.Canvas(null));
    const topRulerWidth = ref(canvas.value.getWidth());
    const topRulerHeight = 40;

    const topRulerGroup = ref(new fabric.Group(undefined));

    const baseLineProps: LineProperties = {
      type: "line",
      id: "baseLine",
      name: "baseLine",
      originX: "center",
      originY: "center",
      stroke: "black",
      strokeWidth: 1,
      selectable: false,
      evented: false,
      strokeDashArray: undefined,
    };

    onMounted(() => {
      if (topRulerRef.value) {
        topRulerCanvas.value = makeRulerCanvas(
          topRulerCanvas.value,
          topRulerWidth.value,
          topRulerHeight,
          "top-ruler-container",
          topRulerRef.value
        );

        const rulerLeft = topRulerCanvas.value.getCenter().left;

        topRulerGroup.value = drawTopRuler(
          rulerLeft,
          topRulerWidth.value,
          topRulerHeight,
          baseLineProps,
          canvas.value.getZoom()
        );

        topRulerCanvas.value.add(topRulerGroup.value).renderAll();
      }
    });

    const isResizing = inject<Ref<boolean>>("isResizing", ref(false));
    //Watch for zoomVal and isZooming from BottomToolBar.vue
    //Redraw ruler when user is done zooming canvas to avoid excessive rerenders
    watch([zoomValue, isZooming, isResizing], (newVals: (number | boolean)[]) => {
      const isZooming = newVals[1];
      const isResizing = newVals[2];

      if (!isZooming && !isResizing) {
        topRulerWidth.value = canvas.value.getWidth();
        topRulerCanvas.value.setWidth(topRulerWidth.value);

        topRulerCanvas.value.remove(topRulerGroup.value);

        const rulerLeft = topRulerCanvas.value.getCenter().left;

        topRulerGroup.value = drawTopRuler(
          rulerLeft,
          topRulerWidth.value,
          topRulerHeight,
          baseLineProps,
          canvas.value.getZoom()
        );

        topRulerCanvas.value.add(topRulerGroup.value).renderAll();
      }
    });

    return {
      topRulerRef,
      topRulerCanvas,
    };
  },
});
